<div class="fixed top-4 right-4 z-9999 pointer-events-none p-8 sm:p-0">
  <div class="flex flex-col gap-2 pointer-events-auto">
    @for (msg of messages(); track msg.id) {
      <div
        class="px-4 py-3 rounded-lg shadow-lg text-white"
        [class.bg-green-600]="msg.type === 'success'"
        [class.bg-red-600]="msg.type === 'error'"
        [class.bg-yellow-600]="msg.type === 'warning'"
        [class.toast-enter]="!msg.leaving"
        [class.toast-exit]="msg.leaving"
      >
        {{ msg.text }}
      </div>
    }
  </div>
</div>
